import { render, staticRenderFns } from "./userDashboardNutritionTargets.vue?vue&type=template&id=fd9c2eee"
import script from "./userDashboardNutritionTargets.vue?vue&type=script&lang=js"
export * from "./userDashboardNutritionTargets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports